// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/appInstallRedirect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/Logo_mobile.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainBg{
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 80px;
    height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100%;
}
.MainBg .LogoImageHeader{
    width: 197px;
    height: 60px;
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 0% 0% no-repeat padding-box;
    mix-blend-mode: normal;
    background-size: 100%;
}
.MainBg .lottieWrapper{
    padding: 56px 0;
}
.MainBg .lottieWrapper .lottie{
    width: 300px;
    height: 300px;
}
.MainBg p{
   font-size: 48px;
   line-height: 80px;
   color: #333333;
   font-family: "MetropolisLight";
   font-weight: 100;
}
@media screen and (min-width: 360px) and (max-width: 767px){
    .MainBg{
        height: 100vh;
        background-repeat: no-repeat;
        background-size: auto 100vh;
        padding: 60px;
    }
    .MainBg .LogoImageHeader{
        width: 125px;
        height: 38px;
        background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 0% 0% no-repeat padding-box;
        background-size: 100%;
    }
    .MainBg .lottieWrapper{
        padding: 40px 0;
    }
    .MainBg .lottieWrapper .lottie{
        width: 230px;
        height: 230px;
    }

    .MainBg p{
        font-size: 24px;
        line-height: 32px;
        text-align: center;
    }
    .MainBg + [class*="stickyFooter"]{
        display: none;
    }
}
@media screen and (width: 1080px) and (height: 2340px){
    .MainBg{
        height: 100vh;
        background-repeat: no-repeat;
        background-size: auto 100vh;
        padding: 250px 0;
    }
    .MainBg .lottieWrapper{
        padding: 180px 0;
    }
    .MainBg .lottieWrapper .lottie{
        width: 350px;
        height: 350px;
    }
    .MainBg + [class*="stickyFooter"]{
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/app-redirect/appRedirect.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,yDAAuD;IACvD,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,2FAA2E;IAC3E,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,cAAc;GACd,8BAA8B;GAC9B,gBAAgB;AACnB;AACA;IACI;QACI,aAAa;QACb,4BAA4B;QAC5B,2BAA2B;QAC3B,aAAa;IACjB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,2FAAkF;QAClF,qBAAqB;IACzB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,aAAa;QACb,4BAA4B;QAC5B,2BAA2B;QAC3B,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".MainBg{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding-top: 80px;\n    height: 100vh;\n    background-image: url(\"/public/appInstallRedirect.png\");\n    background-size: 100%;\n}\n.MainBg .LogoImageHeader{\n    width: 197px;\n    height: 60px;\n    background: transparent url('/public/logo.svg') 0% 0% no-repeat padding-box;\n    mix-blend-mode: normal;\n    background-size: 100%;\n}\n.MainBg .lottieWrapper{\n    padding: 56px 0;\n}\n.MainBg .lottieWrapper .lottie{\n    width: 300px;\n    height: 300px;\n}\n.MainBg p{\n   font-size: 48px;\n   line-height: 80px;\n   color: #333333;\n   font-family: \"MetropolisLight\";\n   font-weight: 100;\n}\n@media screen and (min-width: 360px) and (max-width: 767px){\n    .MainBg{\n        height: 100vh;\n        background-repeat: no-repeat;\n        background-size: auto 100vh;\n        padding: 60px;\n    }\n    .MainBg .LogoImageHeader{\n        width: 125px;\n        height: 38px;\n        background: transparent url('/public/Logo_mobile.svg') 0% 0% no-repeat padding-box;\n        background-size: 100%;\n    }\n    .MainBg .lottieWrapper{\n        padding: 40px 0;\n    }\n    .MainBg .lottieWrapper .lottie{\n        width: 230px;\n        height: 230px;\n    }\n\n    .MainBg p{\n        font-size: 24px;\n        line-height: 32px;\n        text-align: center;\n    }\n    .MainBg + [class*=\"stickyFooter\"]{\n        display: none;\n    }\n}\n@media screen and (width: 1080px) and (height: 2340px){\n    .MainBg{\n        height: 100vh;\n        background-repeat: no-repeat;\n        background-size: auto 100vh;\n        padding: 250px 0;\n    }\n    .MainBg .lottieWrapper{\n        padding: 180px 0;\n    }\n    .MainBg .lottieWrapper .lottie{\n        width: 350px;\n        height: 350px;\n    }\n    .MainBg + [class*=\"stickyFooter\"]{\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
